if (!window.hj) {
    window.hj = function(...args) {
        window.hj.q = window.hj.q || [];
        window.hj.q.push(args);
    };
}
export default function hotjar(...args) {
    window.hj(...args);
}
